<template>
  <div class="app-container">
    <el-form ref="form" :model="form" label-position="left" label-width="200px">
      <el-form-item label="首页推荐名称一(654x316)" class="form">
        <el-input
          placeholder="标题"
          v-model="form.product_category_recommend[0].tag"
          :clearable="true"
          maxlength=""
          class="input"
        ></el-input>
        <el-input
          placeholder="名称一"
          v-model="form.product_category_recommend[0].name1"
          :clearable="true"
          maxlength=""
         class="input"
        ></el-input>

        <el-input
          placeholder="概括"
          v-model="form.product_category_recommend[0].desc"
          :clearable="true"
          maxlength=""
          class="input"
        ></el-input
        ><el-input
          placeholder="名称二"
          v-model="form.product_category_recommend[0].name2"
          :clearable="true"
          type="textarea" :rows="3"
          maxlength=""
          class="input-text"
        ></el-input>
        <UploadOne
          v-model="form.product_category_recommend[0].cover"
        ></UploadOne>
      </el-form-item>
      <el-form-item label="首页推荐名称二(654x316)">
        <el-input
          placeholder="标题"
          v-model="form.product_category_recommend[1].tag"
          :clearable="true"
          maxlength=""
          class="input"
        ></el-input>
        <el-input
          placeholder="名称一"
          v-model="form.product_category_recommend[1].name1"
          :clearable="true"
          maxlength=""
          class="input"
        ></el-input>

        <el-input
          placeholder="概括"
          v-model="form.product_category_recommend[1].desc"
          :clearable="true"
          maxlength=""
      class="input"
        ></el-input
        ><el-input
          placeholder="名称二"
          v-model="form.product_category_recommend[1].name2"
          type="textarea" :rows="3"
          :clearable="true"
          maxlength=""
          class="input-text"
        ></el-input>
        <UploadOne
          v-model="form.product_category_recommend[1].cover"

        ></UploadOne>
      </el-form-item>
      <el-form-item label="首页推荐名称三(654x316)">
        <el-input
          placeholder="标题"
          v-model="form.product_category_recommend[2].tag"
          :clearable="true"
          maxlength=""
          class="input"
        ></el-input>
        <el-input
          placeholder="名称一"
          v-model="form.product_category_recommend[2].name1"
          :clearable="true"
          maxlength=""
          class="input"
        ></el-input>

        <el-input
          placeholder="概括"
          v-model="form.product_category_recommend[2].desc"
          :clearable="true"
          maxlength=""
          class="input"
        ></el-input>
        <el-input
          placeholder="名称二"
          v-model="form.product_category_recommend[2].name2"
          type="textarea" :rows="3"
          :clearable="true"
          maxlength=""
          class="input-text"
        ></el-input>
        <UploadOne
          v-model="form.product_category_recommend[2].cover"
        ></UploadOne>
      </el-form-item>
       <el-form-item label="首页推荐名称四(654x316)">
        <el-input
          placeholder="标题"
          v-model="form.product_category_recommend[3].tag"
          :clearable="true"
          maxlength=""
          class="input"
        ></el-input>
        <el-input
          placeholder="名称一"
          v-model="form.product_category_recommend[3].name1"
          :clearable="true"
          maxlength=""
          class="input"
        ></el-input>

        <el-input
          placeholder="概括"
          v-model="form.product_category_recommend[3].desc"
          :clearable="true"
          maxlength=""
          class="input"
        ></el-input>
        <el-input
          placeholder="名称二"
          v-model="form.product_category_recommend[3].name2"
          type="textarea" :rows="3"
          :clearable="true"
          maxlength=""
          class="input-text"
        ></el-input>
        <UploadOne
          v-model="form.product_category_recommend[3].cover"
        ></UploadOne>
      </el-form-item>
      <el-form-item label="个中心分销图片（702x260）"
        ><UploadOne
          v-model="form.distribution_picture"
        ></UploadOne>
      </el-form-item>
    </el-form>
    <el-button size="small" type="priamry" @click="saveData">保存</el-button>
  </div>
</template>

<script>
import request from "@/utils/request";
import UploadOne from "@/components/UploadOne/index.vue";

export default {
  components: {
    UploadOne,
  },
  data() {
    return {
      listLoading: true,
      form: {
        product_category_recommend: [
          {
            id: "",
            tag: "",
            name1: "",
            name2: "",
            desc: "",
            cover: "",
            weight: "99",
            color: "",
          },
          {
            id: "",
            tag: "",
            name1: "",
            name2: "",
            desc: "",
            cover: "",
            weight: "98",
            color: "",
          },
          {
            id: "",
            tag: "",
            name1: "",
            name2: "",
            desc: "",
            cover: "",
            weight: "97",
            color: "",
          },
           {
            id: "",
            tag: "",
            name1: "",
            name2: "",
            desc: "",
            cover: "",
            weight: "96",
            color: "",
          }
        ],
        distribution_picture: "",
      },
      btnLoading: false,
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      this.listLoading = true;
      request({
        url: "/api/backend/recommend",
        method: "get",
        params: "",
      }).then((res) => {
        if (res.data.product_category_recommend.length > 0) {
          for (var i = 0; i < res.data.product_category_recommend.length; i++) {
            this.form.product_category_recommend[i].id =
              res.data.product_category_recommend[i].id;
            this.form.product_category_recommend[i].tag =
              res.data.product_category_recommend[i].tag;
            this.form.product_category_recommend[i].name1 =
              res.data.product_category_recommend[i].name1;
            this.form.product_category_recommend[i].name2 =
              res.data.product_category_recommend[i].name2;
            this.form.product_category_recommend[i].desc =
              res.data.product_category_recommend[i].desc;
            this.form.product_category_recommend[i].cover =
              res.data.product_category_recommend[i].cover;
            this.form.product_category_recommend[i].color =
              res.data.product_category_recommend[i].color;
          }
        }

        this.form.distribution_picture = res.data.distribution_picture;
        this.listLoading = false;
      });
    },
    saveData() {
      for (let i = 0; i < this.form.length - 1; i++) {
        if (!this.form.product_category_recommend[i].cover) {
          this.$message({
            type: "error",
            message: `请上传${this.form.product_category_recommend[i].cover}的图片`,
          });
          return;
        }
      }
      if (!this.form.distribution_picture) {
        this.$message({
          type: "error",
          message: `请上传${this.form.distribution_picture}的图片`,
        });
        return;
      }
      this.$confirm(`此操作将保存主题图片，是否继续？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((result) => {
          this.btnLoading = true;
          request({
            url: "/api/backend/categoryRecommend",
            method: "post",
            data: this.form,
          })
            .then((response) => {
              this.btnLoading = false;
              this.dialogFormVisible = false;
              this.$notify({
                title: "成功",
                message: "保存成功",
                type: "success",
                duration: 2000,
              });
              this.getDetail();
            })
            .catch((err) => {
              this.btnLoading = false;
            });
        })
        .catch((err) => {
          this.$notify.info("已取消");
        });
    },
  },
};
</script>

<style>
.upload-block {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 120px;
  height: 120px;
}
.uploaded-img {
  width: 120px;
  height: 120px;
}
.upload-block:hover {
  border-color: #409eff;
}
.uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
.input{
  width: 300px;
  margin-right:10px;
}
.input-text{
  width: 610px;
  margin-top:10px;
  margin-bottom:10px;
}
</style>
